import { useAtom } from "jotai";
import { Dispatch, SetStateAction, forwardRef, useState } from "react";
import { conversationIDAtom } from "../../atoms/GlobalAtoms";
import usePrevious from "../../hooks/usePrevious";
import BrieChatFeedback from "./BrieChatFeedback";
import BrieChatMenuHeader from "./BrieChatMenuHeader";
import BrieChatSearchGPT from "./BrieChatSearchGPT";
import BrieHome from "./BrieHome";
import BrieMessages from "./BrieMessages";
import { brieMenuPageAtom } from "./BrieChatMenuButton";

export type BriePages =
  | "home"
  | "messages"
  | "chat-gpt"
  | "voice-chat-gpt"
  | "chat-feedback"
  | "voice-chat-feedback"
  | "support";

export type SetBriePage = (update: SetStateAction<BriePages>) => void;
export type SetConvoID = Dispatch<SetStateAction<string>>;
const prevPagesToIgnore: BriePages[] = [
  "voice-chat-feedback",
  "voice-chat-gpt",
];

interface Props {
  pageID: string | undefined;
  viewID: string | undefined;
}

const BrieChatMenu = forwardRef<HTMLDivElement, Props>(
  ({ pageID, viewID }, ref) => {
    const [page, setPage] = useAtom(brieMenuPageAtom);
    const [conversationID, setConversationID] = useAtom(conversationIDAtom);
    const previousPage = usePrevious(page, prevPagesToIgnore);

    return (
      <div className="brie-menu-container " ref={ref}>
        <BrieChatMenuHeader
          page={page}
          setPage={setPage}
          previousPage={previousPage.current}
        />
        <div className="brie-content tw:w-full">
          {page === "home" && <BrieHome />}
          {page === "messages" && (
            <BrieMessages
              setPage={setPage}
              setConversationID={setConversationID}
            />
          )}
          {(page === "chat-gpt" || page === "voice-chat-gpt") && (
            <BrieChatSearchGPT
              page={page}
              setPage={setPage}
              conversationID={conversationID}
              setConversationID={setConversationID}
              pageID={pageID}
              viewID={viewID}
            />
          )}
          {(page === "chat-feedback" || page === "voice-chat-feedback") && (
            <BrieChatFeedback page={page} setPage={setPage} />
          )}
        </div>
        {(page === "chat-gpt" || page === "voice-chat-gpt") && (
          <div className="text-center font-weight-500 pt-1 text-sm">
            How can I improve?{" "}
            <span
              className="text-primary cursor-pointer"
              onClick={() => setPage("chat-feedback")}
            >
              Give Feedback
            </span>
          </div>
        )}
        {page.startsWith("chat-feedback") && (
          <div className="text-center font-weight-500 pt-1 text-sm">
            All feedback is greatly appreciated{" "}
            <span style={{ fontSize: 13 }}>&#128516;</span>
          </div>
        )}
      </div>
    );
  }
);

export default BrieChatMenu;
